import { useCallback, useState } from 'react';

import { isPhoneValid } from './isPhoneValid';
import { formatPhoneNumber } from './formatPhoneNumber';
import { IBaseQuestionProps } from '../../FormContainer/types/internal';
import { getInitialPhoneValue } from './getInitialPhoneValue';
import { EAnswerField } from '../../../types/form';

export const usePhoneValue = (props: IBaseQuestionProps) => {
  const { answersState, setAnswer, setNextStep } = props;

  const [value, setValue] = useState(getInitialPhoneValue(EAnswerField.Phone, answersState));

  const [isValid, setIsValid] = useState(isPhoneValid(value));

  const onChange = useCallback((newValue: string) => {
    const formatted = formatPhoneNumber(newValue);
    setValue(formatted);
    setIsValid(isPhoneValid(formatted));
  }, []);

  const onSubmit = useCallback(
    (cleanPhone: string) => {
      const answer = { answerField: EAnswerField.Phone, value: cleanPhone };

      setAnswer(answer);
      setNextStep({
        ...answersState,
        [EAnswerField.Phone]: answer,
      });
    },
    [setNextStep, setAnswer, answersState],
  );

  return {
    value,
    isValid,
    onChange,
    onSubmit,
  };
};
